import { Disclosure } from "@headlessui/react";
import { ChevronUpIcon, PlusIcon } from "@heroicons/react/20/solid";
import ServiceItem from "../../../shared/components/ServiceItem";
import { useDispatch } from "react-redux";
import { addService, addServiceData } from "../../../../data/booking/actions/booking";
import { startTripEdit } from "../../../../data/booking/actions/map";
import { useTranslation } from "react-i18next";

export default function AddService({ serviceList }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    return (
        <>
            <Disclosure defaultOpen={false}>
                {({ open }) => (
                    <>
                        <Disclosure.Button className="!mt-16 flex w-full items-center py-4 text-left">
                            <div className="flex items-center gap-2">
                                <div>
                                    <PlusIcon className={"h-12 w-12 text-orange-500"} />
                                </div>
                                <div>
                                    <p className="text-2xl font-medium text-gray-900">
                                        {t('booking.add_service2')}
                                    </p>
                                    <p className="text-sm text-gray-500">
                                    {t('booking.click_here_to_add_service')}
                                    </p>
                                </div>
                            </div>
                            <ChevronUpIcon
                                className={` ${
                                    open ? "rotate-180" : ""
                                } ml-auto h-12 w-12 text-orange-500`}
                            />
                        </Disclosure.Button>
                        <Disclosure.Panel>
                            <div className="mb-16 mt-12 flex flex-wrap justify-center gap-8">
                                {serviceList.map((service, index) => {
                                    return (
                                        <ServiceItem
                                            service={service}
                                            key={index}
                                            handleClick={(e) => {
                                                e.preventDefault();
                                                dispatch(addServiceData());
                                                dispatch(addService(service.type));
                                                dispatch(startTripEdit());
                                            }}
                                        />
                                    );
                                })}
                            </div>
                        </Disclosure.Panel>
                    </>
                )}
            </Disclosure>
        </>
    );
}
